import { Components, Theme, ThemeOptions } from '@mui/material/styles';

const getProgressBarTheme = (theme: Theme): ThemeOptions => {
  const progressBarTheme: Components<Theme>['MuiLinearProgress'] = {
    defaultProps: {
      color: 'primary',
    },

    styleOverrides: {
      root: {
        height: 6,
        borderRadius: 4,
        backgroundColor: theme.palette.M3.sys.light['secondary-container'],
      },
      bar: {
        borderRadius: 4,
      },
    },

    variants: [
      {
        props: { color: 'primary' },
        style: {
          '& .MuiLinearProgress-bar': {
            backgroundColor: theme.palette.M3.sys.light.primary,
          },
        },
      },
      {
        props: { color: 'error' },
        style: {
          '& .MuiLinearProgress-bar': {
            backgroundColor: theme.palette.State.error,
          },
        },
      },
      {
        props: { color: 'warning' },
        style: {
          '& .MuiLinearProgress-bar': {
            backgroundColor: theme.palette.State.warning,
          },
        },
      },
      {
        props: { color: 'info' },
        style: {
          '& .MuiLinearProgress-bar': {
            backgroundColor: theme.palette.State.info,
          },
        },
      },
      {
        props: { color: 'success' },
        style: {
          '& .MuiLinearProgress-bar': {
            backgroundColor: theme.palette.State.success,
          },
        },
      },
    ],
  };

  return {
    components: { MuiLinearProgress: progressBarTheme },
  };
};

export default getProgressBarTheme;
